<template>
  <!-- <div class="frmware-detail-bd"> -->
  <custom-dialog
    width="1400px"
    :title="model.title"
    class="way"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="draw-body frmware-detail-bd">
      <div class="info-box">
        <div class="title">
          {{ $t('fms_banl_flow_detail_dialog.yhlsxx') }}
        </div>
        <ul class="information">
          <li>
            <div class="content">
              <div class="key">
                 {{ $t('fms_banl_flow_detail_dialog.jiao_yi_ri') }}
              </div>
              <div class="val">{{$momentLocal(model.data.tradeFinishTime,'YYYY-MM-DD')  || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{
                  $t('fms_banl_flow_detail_dialog.liu_shui_hao')
                }}
              </div>
              <div class="val">{{ model.data.sellerTradeCode || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.wfzhmc') }}
              </div>
              <div class="val">{{ model.data.sellerName || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.wfyhzh') }}
              </div>
              <div class="val">{{ model.data.sellerAccount || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.jylxmfjylx') }}
              </div>
              <div class="val">{{ getDicValue('seller_trade_type', model.data.sellerTradeType) || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.jiao_yi_jin_e') }}
              </div>
              <div class="val">{{`${model.data.sellerTradeType}`==='0'?'-':''}}{{ model.data.totalAmount || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.yu_e') }}
              </div>
              <div class="val">{{ model.data.totalAmount-totalBillTradeAmount }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.dfzhmc') }}
              </div>
              <div class="val">{{ model.data.buyerName || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.dfyhzh') }}
              </div>
              <div class="val">{{ model.data.buyerAccount || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.dfkhyh') }}
              </div>
              <div class="val">{{ model.data.buyerBank || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.zhai_yao') }}
              </div>
              <div class="val">{{ model.data.buyerTradeRemark || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('fms_banl_flow_detail_dialog.he_xiao_zhuang_tai') }}
              </div>
              <div class="val">{{ getDicValue('seller_trade_state', model.data.sellerTradeState)  || '-'  }}</div>
            </div>
          </li>
        </ul>
        <!-- <ul class="information-loog">
          <li>
            <p class="label">
              {{
                  $t('page_content_compatible_firmware_version_number
                }}
            </p>
            <p class="inner">{{ model.data.supportPreVersion || '-' }}</p>
          </li>
          <li>
            <p class="label">
              {{
                  $t('page_content_firmware_description
                }}
            </p>
            <p class="inner">{{ model.data.firmwareDesc || '-' }}</p>
          </li>
        </ul> -->
      </div>
      <div class="table-box">
        <p class="title">
          {{ $t('fms_banl_flow_detail_dialog.glsbzdxx') }}
        </p>
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-radio-group v-model="formSearch.type" @change="onPageChange({ page: 1 })">
              <el-radio-button :label="item.value" v-for="(item, index) in billType" :key="index">{{ item.label }}</el-radio-button>
            </el-radio-group>
          </el-form>
          </div>

        <div class="table-bd">
          <!-- 去掉了按期查看 -->
          <!-- <custom-table
            v-if="formSearch.type==='M'"
            height="100%"
            :data="tableList"
            :column="tableColumn"
            :index="true"
            tableCode='bankFlow_month'
            @filter="filterChange"
            @sort="sortChange"
          ></custom-table> -->
          <custom-table
            v-if="formSearch.type==='P'"
            height="100%"
            :data="tableList"
            :column="tableColumn"
            :index="true"
            tableCode='bankFlow_period'
            @filter="filterChange"
            @sort="sortChange"
          ></custom-table>
        </div>
      </div>
    </div>
  </custom-dialog>
  <!-- </div> -->
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        sellerTradeCode: '',
        type: 'P'
      },
      tableList: [],
      totalRows: 0,
    };
  },
  computed: {
    totalBillTradeAmount: vm => vm.tableList.reduce((pre, t) => t.billTradeAmount + pre, 0).toFixed(2),
    billType() {
      return [
        {
          label: this.$t('fms_banl_flow_detail_dialog.an_qi_xian_shi'),
          value: 'P'
        }
      ];
    }
  },
  mounted() {
    this.initDialog();
  },
  methods: {

    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      // 赋值产品id
      this.formSearch.sellerTradeCode = this.model.data.sellerTradeCode;

      this.getTableList();
    },


    // 获取列表
    getTableList() {
      this.$getJSON(`${apis.fmsPaymentWriteoffListByTrade}/${this.formSearch.sellerTradeCode}`,).then((res) => {
        this.tableList = res.data;
        // this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 切换页 和搜索
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      // 更新参数列表
      this.getTableList();
    },
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getTableList();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },

  },
};
</script>

<style lang="scss">
// .frmware-detail-bd {

.frmware-detail-bd {
  display: flex;
  height: 100%;
  position: relative;
  // .el-drawer__body {
  //   height: calc(100% - 55px);
  //   padding: 0 !important;
  //   display: flex;
  .info-box {
    flex: 0 0 300px;
    width: 300px;
    background-color: rgba(248, 249, 251, 1);
    padding: 0 24px 24px;
    // height: 100%;
    .title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }
    .information {
       > li {
            padding: 8px 0 7px 0;
            border-bottom: 1px solid rgba(238, 242, 247, 1);
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
          .content {
            overflow: hidden;
            line-height: 18px;
            .key {
              width: 40%;
              float: left;
            }
            .val {
              float: right;
              width: 60%;
              text-align: right;
              word-break: break-all;

            }
          }
        }
    }
    .information-loog {
      .line {
        // display: flex;
        padding-bottom: 11px;
        border-bottom: 1px solid rgba(238, 242, 247, 1);
        .label {
          height: 34px;
          line-height: 34px;
          font-size: 12px;
          color: rgba(108, 117, 125, 1);
        }
        .inner {
          font-size: 12px;
          color: rgba(152, 166, 173, 1);
          line-height: 17px;
          width: 100%;
          word-wrap: break-word;
          word-break: break-all;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
  .table-box {
    flex: 1;
    padding: 0 24px 24px;
    display: flex;
    flex-direction: column;
    .title {
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
    }
    .table-bd {
      flex: 1;
      height: auto;
    }

  }

  // }
}
// }
</style>
